import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={props.width||439}
    height={undefined}
    style={{aspectRatio:1}}
    viewBox="0 0 439 439"
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M420.05 90.98v257.54c0 40.28-32.7 72.98-72.98 72.98H89.53c-40.28 0-72.98-32.7-72.98-72.98V92.77C16.55 51.5 50.05 18 91.32 18h255.75c40.28 0 72.98 32.7 72.98 72.98Z"
      opacity={0.5}
    />
    <mask
      id="ad3a"
      width={404}
      height={404}
      x={17}
      y={18}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M421 90.98v257.54c0 40.28-32.7 72.98-72.98 72.98H90.48c-40.28 0-72.98-32.7-72.98-72.98V92.77C17.5 51.5 51 18 92.27 18h255.75C388.3 18 421 50.7 421 90.98Z"
      />
    </mask>
    <g mask="url(#ad3a)">
      <path
        fill="#CDA4F6"
        d="M285.61 265.35v22.32c0 3.84 3.11 6.95 6.95 6.95h171.9v-36.21h-171.9c-3.84 0-6.95 3.11-6.95 6.95v-.01Z"
      />
      <path
        fill="#AEFFE2"
        d="M376.87 265.35v22.32c0 3.84 3.11 6.95 6.95 6.95h80.64v-36.21h-80.64c-3.84 0-6.95 3.11-6.95 6.95v-.01Z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="M383.95 265.06h73.43M383.95 271.04h73.43M383.95 277.01h73.43"
      />
      <path
        fill="#24EAA8"
        d="M456.9 200.99v4.29c0 3.84-3.11 6.95-6.95 6.95h-162.7v-18.19h162.7c3.84 0 6.95 3.11 6.95 6.95Z"
      />
      <path
        fill="#fff"
        d="M370.34 200.99v4.29c0 3.84-3.11 6.95-6.95 6.95h-76.14v-18.19h76.14c3.84 0 6.95 3.11 6.95 6.95Z"
      />
      <path
        stroke="#24EAA8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="M292.73 199.14h68.4M292.73 205.12h68.4"
      />
      <path
        fill="#FF7458"
        d="M464.37 160.91v26.18c0 3.84-3.11 6.95-6.95 6.95h-162.7v-40.08h162.7c3.84 0 6.95 3.11 6.95 6.95Z"
      />
      <path
        fill="#fff"
        d="M377.81 160.91v26.18c0 3.84-3.11 6.95-6.95 6.95h-76.14v-40.08h76.14c3.84 0 6.95 3.11 6.95 6.95Z"
      />
      <path
        stroke="#24EAA8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="M301.74 160.67h68.39M301.74 166.65h68.39M301.74 172.62h68.39"
      />
      <path
        stroke="#1B113F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="M390.4 160.67v27.43M399.98 160.67v27.43"
      />
      <path
        fill="#425596"
        d="M287.25 219.18v18.38c0 3.84 3.11 6.95 6.95 6.95h162.7v-32.28H294.2c-3.84 0-6.95 3.11-6.95 6.95Z"
      />
      <path
        fill="#FF7458"
        d="M373.81 219.18v18.38c0 3.84 3.11 6.95 6.95 6.95h76.14v-32.28h-76.14c-3.84 0-6.95 3.11-6.95 6.95Z"
      />
      <path
        fill="#24EAA8"
        d="M291.78 251.46c0 3.84 3.11 6.95 6.95 6.95h171.9v-13.9h-171.9c-3.84 0-6.95 3.11-6.95 6.95Z"
      />
      <path
        fill="#fff"
        d="M383.04 251.46c0 3.84 3.11 6.95 6.95 6.95h80.64v-13.9h-80.64c-3.84 0-6.95 3.11-6.95 6.95Z"
      />
      <path
        fill="#24EAA8"
        d="M39.26 243.22v4.41c0 3.81 3.08 6.89 6.89 6.89h162.76v-18.19H46.15c-3.81 0-6.89 3.08-6.89 6.89Z"
      />
      <path
        fill="#fff"
        d="M125.83 243.22v4.41c0 3.81 3.08 6.89 6.89 6.89h76.2v-18.19h-76.2c-3.81 0-6.89 3.08-6.89 6.89Z"
      />
      <path
        fill="#24EAA8"
        d="M35.82 307.58v17.78c0 3.81 3.08 6.89 6.89 6.89h181.73v-31.56H42.71c-3.81 0-6.89 3.08-6.89 6.89Z"
      />
      <path
        fill="#FF7458"
        d="M132.06 307.58v17.78c0 3.81 3.08 6.89 6.89 6.89h85.49v-31.56h-85.49c-3.81 0-6.89 3.08-6.89 6.89Z"
      />
      <path
        stroke="#1B113F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="M62.38 309.99H51v11.38h11.38v-11.38Z"
      />
      <path
        fill="#425596"
        d="M212.54 261.4v18.5c0 3.81-3.08 6.89-6.89 6.89H26.72v-32.28h178.93c3.81 0 6.89 3.08 6.89 6.89Z"
      />
      <path
        fill="#fff"
        d="M117.73 261.4v18.5c0 3.81-3.08 6.89-6.89 6.89H26.72v-32.28h84.11c3.81 0 6.89 3.08 6.89 6.89h.01Z"
      />
      <path
        stroke="#24EAA8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="M35.82 261.42h74.09M35.82 267.39h74.09M35.82 273.37h74.09"
      />
      <path
        stroke="#1B113F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="M159.67 267.39h-25.79v7.41h25.79v-7.41Z"
      />
      <path
        fill="#AEFFE2"
        d="M198.55 293.68v.12c0 3.81-3.08 6.89-6.89 6.89H19.7v-13.9h171.96c3.81 0 6.89 3.08 6.89 6.89Z"
      />
      <path
        fill="#FF7458"
        d="M107.29 293.68v.12c0 3.81-3.08 6.89-6.89 6.89H19.7v-13.9h80.7c3.81 0 6.89 3.08 6.89 6.89Z"
      />
      <path
        fill="#425596"
        d="M336.41 372.01v22.66c0 4.66 3.78 8.44 8.44 8.44h195.67v-39.55H344.85c-4.66 0-8.44 3.78-8.44 8.44v.01Z"
      />
      <path
        stroke="#1B113F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="M438.47 379.09h-33.63v8.66h33.63v-8.66Z"
      />
      <path
        fill="#24EAA8"
        d="M362.56 349.73v5.4c0 4.66 3.78 8.44 8.44 8.44h175.87v-22.28H371c-4.66 0-8.44 3.78-8.44 8.44Z"
      />
      <path
        fill="#CDA4F6"
        d="M353.55 411.56v.14c0 4.66 3.78 8.44 8.44 8.44h187.14v-17.03H361.99c-4.66 0-8.44 3.78-8.44 8.44v.01Z"
      />
      <path
        fill="#FF7458"
        d="M289.99 427.22c-42.37-35.98-64.39-63.54-79.03-118.07-14.64-54.53-.82-2.37-.82-2.37l148.21-15.2c32.14 23.01 49.24 52.61 58.16 126.2l-126.53 9.45.01-.01Z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="M335.57 357.3c11.19 19.01 22.38 38.02 33.56 57.03M304.87 317.47c3.33 5.65 6.67 11.29 10 16.94 2.86-1.79 5.05-3.32 7.91-5.1-2.93-4.88-6.21-8.67-9.14-13.55"
      />
      <path
        fill="#F7C5B5"
        d="m390.4 286.04-9.37-13.5-17.96 25.17s-9.22 8.79-12.23 11.74c-3.02 2.95-1.42 3.82-1.42 3.82l11.7-2.03 9.15 2.57s3.24-2.68 6.25-5.24l11.55-2 2.32-20.53h.01Z"
      />
      <path
        stroke="#1B113F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="M354.77 305.5c6.63-2.79 13.25-5.58 19.88-8.36-1.78-1.7-3.82-3.2-5.61-4.89M361.16 311.67l17-2.97"
      />
      <path
        stroke="#1B113F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="M367.56 296.51c-.87 1.33-1.74 2.67-2.61 4"
      />
      <path
        fill="#F7C5B5"
        d="m331.28 229.14 32.05 30.84-46.59 23.01-23.36-39.85 37.9-14Z"
      />
      <path
        fill="#24EAA8"
        d="M273.6 198.24c21.47 3.45 24.78 5.64 39.66 14.96 11.94 7.48 22.56 17.61 22.56 17.61l-44.14 25.29-18.08-57.86Z"
      />
      <path
        stroke="#1B113F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="m298.4 246.96 31.08-19.47"
      />
      <path
        fill="#24EAA8"
        d="m222.8 190.21-46.89 14.02 17.04 66.8 76.54 31.32s78.77-21.7 78.12-21.42c-.65.28-40.79-16.36-40.79-16.36l-33.22-66.33-50.81-8.04.01.01Z"
      />
      <path
        stroke="#1B113F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="M306.53 264.25c-1.39 1.3-2.78 2.61-4.17 3.91"
      />
      <path
        fill="#fff"
        d="M235.26 245.37s51.78-.06 94.68 64.05l-92.97-.96-46.43-.48 44.72-62.6v-.01Z"
      />
      <path
        fill="#fff"
        d="M395 252.8h-57.09l-76.52 56.35 69.89 3.76L395 252.8Z"
      />
      <path
        fill="#fff"
        d="m395 252.8-35.53 24.08a93.052 93.052 0 0 0-29.53 32.54l-.48-.12a231.785 231.785 0 0 0-56.3-6.94h-76.84l-6.19 16.26 132.33.71 13.31-2.36 69.08-50.85-9.84-13.33-.01.01Z"
      />
      <path
        stroke="#1B113F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="M202.72 302.35h63.43c25.82 0 41.81.07 63.78 7.06 0 0 5.43-15.54 27.05-30.53 21.62-14.99 38.01-26.09 38.01-26.09"
      />
      <path
        stroke="#1B113F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="M303.18 277.73s15.36 13.85 26.75 31.68M234.68 302.39v14.95M323.33 316.21c3.06-5.41 10.2-8.13 16.09-6.12"
      />
      <path
        fill="#425596"
        d="M324.14 321.54H184.78v-4.43h139.36c5.3 0 10.56-1.74 14.81-4.89l64.57-47.87 2.64 3.56-64.57 47.87c-5.01 3.72-11.21 5.76-17.45 5.76Z"
      />
      <path
        fill="#F7C5B5"
        d="M192.23 253.97c.16 1.52.63 3.28.79 4.81 6.94-5.28 14.68-9.96 20.91-16.08 6.06-5.96 13.99-11.34 22.49-11.58 9.95-.28 19.9-.55 29.86-.83.8 1.3.44 3.02-.56 4.17-1.01 1.15-2.44 1.82-3.83 2.46-3.71 1.7-7.41 3.4-11.12 5.09l13.39 12.15s15.29 7.89 18.03 9.72c2.74 1.83 1.39 3.51 1.39 3.51h-2.55s3.56 1.54 2.88 3.64L259 268.69s12.45 2.85 14.63 3.52c2.18.66 2.44 2.6 2.44 2.6l-12.86 1.46-8.76 3.56-23.16-2.78s-19.04 20.38-33.67 36.78c-14.62 16.4-53.69 11.8-49.79-22.25 3.9-34.05 4.68-39.91 4.68-39.91l39.75 2.3h-.03Z"
      />
      <path
        stroke="#1B113F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="m248.54 241.32 3.39 2.22M255.41 260.77c9.12 2.41 18.24 4.81 27.36 7.22M249.87 267.96c6.03.78 12.06 1.56 18.09 2.33M245.01 274.97c8.12.43 16.25.87 24.37 1.3M161.5 285.92c1.05-3.6 4.42-6.41 8.15-6.79 7.43-7.49 15.31-14.42 23.74-20.77"
      />
      <path
        fill="#24EAA8"
        d="M146.85 252.8s6.88-18.87 11.98-30.43c5.1-11.55 8.54-15.59 17.08-18.14 8.54-2.55 15.04 5.55 17.04 21.19s3.37 29.2 3.37 29.2l-49.47-1.82Z"
      />
      <path
        stroke="#1B113F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="M149.85 247.14c15.03.1 30.07.21 45.1.31"
      />
      <path
        fill="#425596"
        d="M101.48 328.51v58.32c0 3.81 3.08 6.89 6.89 6.89h176.05v-72.1H108.37c-3.81 0-6.89 3.08-6.89 6.89Z"
      />
      <path
        fill="#AEFFE2"
        d="M194.83 328.51v58.32c0 3.81 3.08 6.89 6.89 6.89h82.71v-72.1h-82.71c-3.81 0-6.89 3.08-6.89 6.89Z"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="M203.43 328.82h74.09M203.43 334.8h74.09M203.43 340.77h74.09"
      />
      <path
        stroke="#1B113F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.48}
        d="M180.01 328.82v50.67M168.07 328.82v50.67M122.47 345.88v17.69"
      />
      <path
        fill="#24EAA8"
        d="M146.69 148.66c5.13 5.81 4.58 14.67-1.23 19.8-5.81 5.13-14.67 4.58-19.8-1.22-5.13-5.81-4.58-14.67 1.22-19.8 5.81-5.13 14.67-4.58 19.8 1.23l.01-.01Z"
      />
      <path
        fill="#425596"
        d="M105.14 141.03c.72.82 18.89 23.03 18.89 23.03l23.69-13.57-9.88-27.67-32.69 18.21h-.01Z"
      />
      <path
        fill="#fff"
        d="M115.76 149.06c8.56-2.2 16.57-6.18 23.54-11.62.45-.35.36-1.11 0-1.48-.44-.44-1.03-.35-1.48 0-6.67 5.2-14.43 8.97-22.62 11.08-1.3.33-.75 2.35.56 2.02ZM123.46 155.61c6.55-2.27 12.79-5.38 18.52-9.29 1.1-.75.06-2.57-1.06-1.81a76.017 76.017 0 0 1-18.02 9.08c-1.26.44-.72 2.46.56 2.02Z"
      />
      <path
        fill="#24EAA8"
        d="M126.666 135.556c20.315-12.605 26.565-39.293 13.959-59.608-12.605-20.315-39.293-26.565-59.608-13.96-20.315 12.606-26.565 39.294-13.96 59.609 12.606 20.315 39.294 26.565 59.609 13.959Z"
      />
      <path
        fill="#fff"
        d="M105.2 125.22c-4.97-10.02-12.04-19-20.65-26.15-1.02-.84-2.09-1.89-3.41-2.22-1.09-.28-2.38 0-3.04.99-.75 1.12-.28 2.52.35 3.57.68 1.11 1.57 2.16 2.52 3.05 1.83 1.72 4.31 2.95 6.86 2.2 2.31-.68 3.95-2.69 4.98-4.77 1.27-2.57 1.91-5.47 2.1-8.32.1-1.51.05-3.03-.15-4.53-.16-1.23-.32-2.56-1.1-3.58-.66-.87-1.81-1.3-2.76-.59-.95.71-1.03 2.06-.54 3.08.57 1.19 1.66 2.25 2.55 3.19.95 1.01 2.02 1.96 3.27 2.59 2.34 1.18 5.21 1.22 7.2-.65 1.75-1.65 2.39-4.16 2.67-6.47.18-1.51.22-3.04.11-4.56-.1-1.42-.23-3-.73-4.34-.37-1.02-1.19-2.05-2.41-1.78-1.05.23-1.48 1.28-1.57 2.25-.11 1.15.32 2.32.76 3.37.49 1.16 1.14 2.22 1.95 3.19 1.62 1.94 3.92 3.34 6.43 3.73 2.51.39 5.22-.07 7.31-1.57a9.051 9.051 0 0 0 3.64-6.03c.17-1.2.09-2.41-.27-3.57-.23-.74-1.44-.64-1.4.19.54 11.23 1.78 22.43 3.72 33.51.55 3.14 1.15 6.26 1.81 9.38.19.92 1.49.5 1.37-.38-.07-.55-.15-1.1-.22-1.65-.12-.9-1.49-.52-1.37.38.07.55.15 1.1.22 1.65l1.37-.38a267.835 267.835 0 0 1-4.87-33.1c-.26-3.13-.46-6.27-.62-9.41l-1.4.19c1.26 4.07-1.49 8.3-5.52 9.28-4.31 1.04-8.51-1.36-10.49-5.19-.45-.88-.89-1.9-1-2.9-.04-.37-.03-1.76.66-1.53.35.12.52.69.61.99.19.63.29 1.29.39 1.93.2 1.25.28 2.52.26 3.78-.04 3.65-1.1 10.04-6.22 9.03-2.35-.46-4.07-2.22-5.58-3.97-.57-.66-1.73-1.67-1.5-2.65.27-1.16 1.17-.02 1.39.51.43 1.05.5 2.32.59 3.44.09 1.24.08 2.5-.03 3.74-.21 2.36-.78 4.81-1.82 6.95-.82 1.69-2.07 3.48-3.92 4.12-2.09.72-4.11-.28-5.64-1.69-.79-.73-4.26-4.17-2.44-5.18.96-.53 2.06.25 2.79.82.91.71 1.79 1.46 2.66 2.22a79.428 79.428 0 0 1 17.31 21.5c.56 1.01 1.09 2.04 1.6 3.07.41.82 1.64.1 1.23-.72l-.01-.01Z"
      />
      <path
        fill="#FF7458"
        d="M162.65 135.26c.13-6.02 5.02-10.69 11.05-10.59 6.17.1 10.26 4.57 10.44 10.82.06 6.25-4.09 10.97-10.58 11.04-6.64.07-11.06-4.8-10.92-11.26l.01-.01Zm3.45-22.02-2.54-41.7a6.834 6.834 0 0 1 6.75-7.25l4.73-.05c3.91-.04 7.05 3.2 6.9 7.1l-1.6 41.74a5.791 5.791 0 0 1-5.73 5.57l-2.67.03a5.797 5.797 0 0 1-5.84-5.44Z"
      />
      <path
        fill="#F7C5B5"
        d="M229.82 193.39c-.28-5.18-.52-9.58-.52-9.58s-3.98 2.78-7.59 3.45c-3.61.67-7.11-1.44-7.16-1.47-.04-.03-4.2-2.45-4.2-2.45s-.05.92-.14 2.41c-.22 3.74-.67 11.08-1 16.66 2.69 3.81 6.77 6.83 12.93 7.42.22.02.43.05.66.07 1.47.1 2.75.07 3.88-.03 1.66-.15 2.99-.49 4.01-.99-.15-2.57-.53-9.54-.86-15.49h-.01Z"
      />
      <path
        fill="#F79E8F"
        d="M209.49 184.17s5.85 10.68 12.82 9.15c7.28-1.6 7.55-10.91 7.55-10.91l-20.37 1.76Z"
      />
      <path
        fill="#F7C5B5"
        d="M239.41 154.69c0 8.15-1.13 15.19-2.27 20.19-1.11 4.89-4.23 8.31-8.64 11.06l-.8.5c-4.67 2.91-10.69 2.98-15.43.17-4.78-2.83-8.12-6.56-9.15-11.8-1.87-9.54-2.08-20.11-2.08-20.11s-1.78-20.59 18.91-20.19c20.69.4 19.46 20.19 19.46 20.19v-.01Z"
      />
      <path
        fill="#F7C5B5"
        d="M203.3 174.02c-3.65 3.15-11.32-9.32-7.79-12.68 3.53-3.36 6.03 2.11 6.03 2.11l.72 3.94 1.07 5.3.27 1.19-.29.14h-.01Z"
      />
      <path fill="#F79E8F" d="M197.09 165.54s1.49-3.23 4.96 2.44l-4.96-2.44Z" />
      <path
        fill="#F7C5B5"
        d="M237.13 174.1c3.7 3.09 11.16-9.51 7.57-12.81-3.59-3.3-5.99 2.21-5.99 2.21l-.65 3.95-.97 5.32-.25 1.19.3.14h-.01Z"
      />
      <path fill="#F79E8F" d="M243.19 165.51s-1.55-3.2-4.92 2.53l4.92-2.53Z" />
      <path
        fill="#000"
        d="M212.96 161.43c0 1.05-.85 1.91-1.91 1.91s-1.91-.85-1.91-1.91.85-1.91 1.91-1.91 1.91.85 1.91 1.91ZM230.62 161.43c0 1.05-.85 1.91-1.91 1.91s-1.91-.85-1.91-1.91.85-1.91 1.91-1.91 1.91.85 1.91 1.91ZM224.02 154.74l8.51 2.2c.58.15 1.07-.49.75-1-.62-.98-1.89-2.24-4.43-2.87-2.56-.64-4.15-.11-5.04.46-.49.31-.34 1.06.22 1.21h-.01ZM214.82 154.74l-8.51 2.2c-.58.15-1.07-.49-.75-1 .62-.98 1.89-2.24 4.43-2.87 2.56-.64 4.15-.11 5.04.46.49.31.34 1.06-.22 1.21h.01Z"
      />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.07}
        d="M212.96 170.98s2.24 4.05 10.71 2.69"
      />
      <path
        fill="#141C34"
        d="M201.69 164.33s4.41-14.23 1.22-23.43c0 0-9.98 4.95-1.22 23.43ZM238.58 164.33s-5.57-14.23-2.37-23.43c0 0 10.04 3.81 2.37 23.43Z"
      />
      <path
        fill="#24EAA8"
        d="m205.4 213.97 3.37-12.04 5.94 2.09s10.44 3.37 17.67-3.53c7.23-6.91 4.5 12.2 4.5 12.2l-18.95 8.19-12.53-4.66v-2.25Z"
      />
      <path
        fill="#141C34"
        d="M200.7 152.91s8.47-2.48 14.66-6.61c6.19-4.13 6.61-2.68 4.13.83-2.48 3.51-1.65 5.37 4.34.83s7.85-2.06 10.94 1.24 6.88 1.88 6.29-1.66c-.41-2.46.32-11.76-12.07-14.65-12.39-2.89-27.26 1.65-29.94 12.6-2.68 10.94 1.65 7.43 1.65 7.43v-.01Z"
      />
      <path
        fill="#141C34"
        d="m203.12 146.83-4.18 9.19s-1.91-4.55-1-11.46c.91-6.91 7.73-12.28 14.46-13.37 6.73-1.09 13.83-1.55 18.65.27 4.82 1.82 12.46 5.73 10.46 19.38-2 13.64-3.18-6.37-3.18-6.37l-6.64-8.73-12.46-1.46-7.91 4.09-3.82 4.55-3.18 6.73-1.18-2.82h-.02Z"
      />
    </g>
    <path
      stroke="#1B113F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.48}
      d="M233.8 199.06c-3.78 4.24-9.57 6.6-15.24 6.21-5.67-.4-11.08-3.54-14.22-8.27"
    />
    <path
      stroke="#FF7458"
      strokeMiterlimit={10}
      strokeWidth={5}
      d="M436 90.98v257.54c0 48.56-39.42 87.98-87.98 87.98H90.48c-48.56 0-87.98-39.42-87.98-87.98V92.77C2.5 43.23 42.72 3 92.27 3h255.75C396.58 3 436 42.42 436 90.98Z"
    />
    <path
      stroke="#FF7458"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M421 90.98v257.54c0 40.28-32.7 72.98-72.98 72.98H90.48c-40.28 0-72.98-32.7-72.98-72.98V92.77C17.5 51.5 51 18 92.27 18h255.75C388.3 18 421 50.7 421 90.98Z"
    />
    <path fill="url(#ad3b)" d="M167.02 130.7h78.24v78.24h-78.24z" opacity={0.3} />
    <path fill="url(#ad3c)" d="M193.9 130.7h78.24v78.24H193.9z" opacity={0.3} />
    <path
      fill="#F79E8F"
      d="M221.42 167.19h-2.11c-.34 0-.58-.33-.48-.65l.96-3.06c.14-.46.78-.47.95-.03l1.15 3.06c.12.33-.12.68-.47.68Z"
    />
    <defs>
      <pattern
        id="ad3b"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#ad3d" transform="scale(.0031 .00309)" />
      </pattern>
      <pattern
        id="ad3c"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#ad3e" transform="scale(.00307 .00309)" />
      </pattern>
      <image
        xlinkHref="data:image/png;base64,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"
        id="ad3d"
        width={323}
        height={324}
        preserveAspectRatio="none"
      />
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUYAAAFECAYAAABbH5f7AAAACXBIWXMAAC4jAAAuIwF4pT92AAAGp0lEQVR4nO3da04bWRAG0IIwcSDPNWYHWQk7YI2TSTIOYPD8oCsuX7Xttm8jlMw5UqnBBotI0afqvq8IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGDE2Uv/Afw/LG+uz+L0/2/ry89f1nP+PbCPYORZlCA8i4jzUu3rY/8H1xHxOFzz68f2dWHJcxGMzKoE4qvYDsSL8lr7XgZkDcGsh6ba9wQksxOMzGYIxQy+rAzEv4avL5rXszIYawiuhuv98PWqef1XWApH5iQYmUUJxTYI8/p6qIuR99pgXMUmDO+Humtey2v+vHBkNoKRbk0oZuC9Ltesxcjru4LxLjZheDvUffN6DUvhyGwEI11GQrENwqw3Qy1iOyT3BePtcP051G1Td6WEI7O5eOk/gN9eDrTk7XOG4pumLoeqrx0KxgzE9vlkO5q9Hik4mY6Rkw3dYu0Ua3d4GRFXsQnEq+b7qcG4jIh/h1qWyu9rJ/mrc9Q10kPHSI86Cp3PFjMYr5p6GxHvyvdTg3ExfG52pbVbrPMc63Se/Cw4iWCkR32+mLfRbceYgfguIt4P37+N6cH4OrbnP9ZQzCBs5zq6E6KLYKRHTs7OjnEsGDMUP8RTML4fvj82GMe6xRqMq1KvljfXBmE4mWCkRw68ZMdYb6Vrx5iB+DE2AXlMMNalhBGb2+c6AbxO21mF22k6CEZO0qxyOdQtZih+Gq7HBmM7Ap2heF9+Nuc1jo1aw1EEI6eqwXioW/wQm2D8FMcHY8T2QEtdEVMngOe0nrzFf3iefzp/OsFIj3YOYw7A7Bp8qd1jDcZ2E4kMxsXwfrtxRAZjTgLPAK2j1zpGTiYY6TG26qWuctlXi/J7bTDW54kPEz6nhqLbaLoJRnrUUel2XfShakMxYjtoI56C8i423ei+qrv1CEa6CEZ6tAMwx9ZYd1fDcR3TQrGGo46Rbucv/Qfw22v3X5xSdXPaMe2u38eUUKSbYKTXWUe9xOfCQYKRXmM720ytl/hcOEgw0mtsrfKhqodbjRk7+2VqCUa6CUZ61J1tVifUWJDVuYztRO5Dtesz4ShGpelRJ13XYwemVD4L3DXBuy71mxqK2ZEKRroIRnqMBVmuRNlXi/L769i98uXQ5+QmtRmgeZsuGOkiGOlRjzutp/nlztu5KmVscvdDbCZvt8GYn/UzIr6N1PeI+BHbO3jXcNQ10kUw0mNfx7iMzVK99qyWx3hazpcTsw8F498R8TW2QzGPO8hgbJ8zPj7jv5s/nGDkVO3ASw3F3J+xTuY+L7+X65+nBuPXiPhnqG+xCca2Y8znjG6n6SIYOcnl5y/r5c113QIsb4t/xmaJYLsapQ7WHBOM32ITjN+HqsFYz5o2Mk03wUiPdiuwu9jcNtfR5nbn7WOD8XtzHesYt0amHWtAD8FIj3bj2LoWut3lpn0eOTUY85nij9h+vjg28KJbZBaCkR7tc8b7GO8Sx3benhqMdaClni/dDrx4vshsLLiny/Lmemyj2tzFO+uy1NVwnRqMGYLLUnUeYw765ODL6vLzFyPSdNEx0itHmc/iKczGbp/brvI2ngL0UDDumiyeZ7zUQRfzF5mNjpFu5cTA7BxzN++8Lsp1EdvHEewLxuwGaxDWZ4r12eIqIpwlzSwEI7NowjGPOqjnTeeqlxqa+f5YMNZpQHUd9n3zfnaiQpHZCEZm05w1nVW7yBqU9f2xtdLtUsN6jnR9/yGEIjMTjMxqCMc8VrUelnXRXM9je5lgBmMd6a7PJuu1PrdcC0XmJhh5FiUg25Cscxx3HUVQd+OuQfgrDEMg8owEI8+uCcljD6zKDlIYAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwx/gPgycNBBDeMikAAAAASUVORK5CYII="
        id="ad3e"
        width={326}
        height={324}
        preserveAspectRatio="none"
      />
    </defs>
  </svg>
)
export default SvgComponent
